import { jsx as _jsx } from "react/jsx-runtime";
import { Menu as HeadlessMenu } from '@headlessui/react';
export const Menu = ({ children, ...props }) => {
    return _jsx(HeadlessMenu, { ...props, children: children });
};
